import { type WithClassName, type WithEntitiesSource, type WithId, type WithParentId } from "@client/types";

export const idPropsSelector = (state: any, props: WithId) => props.id;
export const entitiesSourcePropsSelector = (state: any, props: WithEntitiesSource) => props.source;
export const classNamePropsSelector = (state: any, props: Partial<WithClassName>) => props.className;
export const parentIdPropsSelector = (state: any, props: WithParentId) => props.parentId;

export const moduleTypePropsSelector = (state: any, props: { moduleType: string }) => props.moduleType;

export type WithPrefix = {
  prefix: string;
};
export type PrefixPropsSelector = (state: any, props: Partial<WithPrefix>) => string | undefined;
export const prefixPropsSelector = (state: any, props?: Partial<WithPrefix>) => props?.prefix;
